/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Buy_MessagesInputs */

const es_admin_company_overview_buy_messages = /** @type {(inputs: Admin_Company_Overview_Buy_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar mensajes`)
};

const en_admin_company_overview_buy_messages = /** @type {(inputs: Admin_Company_Overview_Buy_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy messages`)
};

/**
* | output |
* | --- |
* | "Buy messages" |
*
* @param {Admin_Company_Overview_Buy_MessagesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_buy_messages = /** @type {((inputs?: Admin_Company_Overview_Buy_MessagesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Buy_MessagesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_buy_messages(inputs)
	return en_admin_company_overview_buy_messages(inputs)
});
export { admin_company_overview_buy_messages as "admin.company_overview.buy_messages" }